export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";